import { db } from "../infra/firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { formatInTimeZone } from "date-fns-tz";

const TIMEZONE = "America/Sao_Paulo";

const getTimestamp = () =>
  formatInTimeZone(new Date(), TIMEZONE, "yyyy-MM-dd'T'HH:mm:ssXXX");

export const savePartialLeadToFirebase = async (leadData) => {
  if (!db) {
    console.warn("[Firebase] Firestore not initialized, skipping partial lead save");
    return { success: false };
  }

  const phoneId = leadData.phone;
  if (!phoneId) {
    console.warn("[Firebase] No phone number, skipping partial lead save");
    return { success: false };
  }

  try {
    const docRef = doc(db, "partialLeads", phoneId);
    const now = getTimestamp();

    const existing = await getDoc(docRef);
    const createdAt = existing.exists() ? existing.data().createdAt : now;

    await setDoc(docRef, { ...leadData, createdAt, updatedAt: now }, { merge: true });
    console.log(`[Firebase] Partial lead saved (step ${leadData.lastStep}, phone: ${phoneId})`);
    return { success: true };
  } catch (error) {
    console.error("[Firebase] Error saving partial lead:", error);
    return { success: false };
  }
};

export const saveCompleteLeadToFirebase = async (leadData) => {
  if (!db) {
    console.warn("[Firebase] Firestore not initialized, skipping complete lead save");
    return { success: false };
  }

  const emailId = leadData.email;
  if (!emailId) {
    console.warn("[Firebase] No email, skipping complete lead save");
    return { success: false };
  }

  try {
    const now = getTimestamp();
    const referenceNumber = "BIAN" + Math.random().toString(36).substring(2, 6).toUpperCase();

    await setDoc(doc(db, "preRegistrations", emailId), {
      ...leadData,
      referenceNumber,
      timestamp: now,
      submittedAt: new Date().toISOString(),
    });
    console.log(`[Firebase] Complete registration saved (email: ${emailId})`);

    if (leadData.phone) {
      const completion = {
        status: "complete",
        completedAt: now,
        lastStep: 8,
      };
      // Firestore rejeita undefined: só grava needs quando o lead traz o campo
      if (leadData.needs !== undefined) completion.needs = leadData.needs;

      await setDoc(doc(db, "partialLeads", leadData.phone), completion, { merge: true });
      console.log(`[Firebase] Partial lead marked complete (phone: ${leadData.phone})`);
    }

    return { success: true };
  } catch (error) {
    console.error("[Firebase] Error saving complete lead:", error);
    return { success: false };
  }
};
